// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/baggage-cargo-stowage.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/baggage-cargo-stowage/baggage-cargo-stowage.js';

mount([g0]);
